export default {
  RESTRICT_CONVERSATIONS: 'restrict_conversations',
  OWNED_CONTACTS_ONLY: 'restrict_conversations',
};
